import React, { useContext, useEffect, useState } from "react";
import './Components/TheStudentDashboard.css';
import EnrolledPaperCompletionGraph from "./Components/EnrolledPaperCompletionGraph";
import PaperCounts from "./Components/PaperCounts";
import CreditsUsage from "./Components/CreditsUsage";
import PaperDetails from "./Components/PaperDetails";
// StudentAnnouncements import commented out - previous announcements UI & logic disabled
// import StudentAnnouncements from "./Components/StudentAnnouncements";
import { MainContext } from "../../../../../context/main/main-context";
import { Alert, LinearProgress, Snackbar } from "@mui/material";
import Medal from "./Components/imageFiles/Medal.png";

const TheStudentDashboard = () => {

  const {
    student_dashboard_initial_loading,
    student_dashboard_data_loading,
    student_dashboard_data,
    fetchStudentDashboardData
  } = useContext(MainContext)

  const [open, setOpen] = useState(false);

  const [userId] = useState(sessionStorage.getItem("manage_user_id"))
  const [userName, setUserName] = useState(sessionStorage.getItem("username"))

  const [availablePaperCount, setAvailablePaperCount] = useState(0);
  const [enrolledPaperCount, setEnrolledPaperCount] = useState(0);
  const [completedPaperCount, setCompletedPaperCount] = useState(0);
  const [completionPercentage, setCompletionPercentage] = useState(0);
  const [userCredits, setUserCredits] = useState(null);
  const [availablePapers, setAvailablePapers] = useState([]);
  const [enrolledPapers, setEnrolledPapers] = useState([]);
  const [completedPapers, setCompletedPapers] = useState([]);
  // Announcements state commented out - previous announcement data & UI disabled
  // const [allRecentAnnouncements, setAllRecentAnnouncements] = useState([]);
  // const [weeklyAnnouncements, setWeeklyAnnouncements] = useState([]);
  // const [monthlyAnnouncements, setMonthlyAnnouncements] = useState([]);

  useEffect(() => {
    setOpen(false)
  }, [])

  useEffect(() => {
    if (userId) {
      setOpen(false);
      fetchStudentDashboardData(userId);
    }
  }, [userId]);

  useEffect(() => {

    if (student_dashboard_data && student_dashboard_data.success && student_dashboard_data.data) {

      const data = student_dashboard_data.data;


      setAvailablePaperCount(parseInt(data.available_paper_count) || 0);
      setEnrolledPaperCount(parseInt(data.enrolled_paper_count) || 0);
      setCompletedPaperCount(parseInt(data.completed_paper_count) || 0);
      setCompletionPercentage(parseInt(data.enrolled_paper_completing_level) || 0);
      setUserCredits(data.user_credits || null);
      setAvailablePapers(data.available_papers || []);
      setEnrolledPapers(data.enrolled_papers || []);
      setCompletedPapers(data.completed_papers || []);
      // Announcements assignment commented out - announcements logic disabled
      // setAllRecentAnnouncements(data.all_recent_announcement || []);
      // setWeeklyAnnouncements(data.weekly_announcement || []);
      // setMonthlyAnnouncements(data.monthly_announcement || []);

      setOpen(false);

    }
    else if (student_dashboard_data && !student_dashboard_data.success) {
      setOpen(true)
    }
  }, [student_dashboard_data])

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };



  return (
    <>
      {student_dashboard_data_loading && !student_dashboard_initial_loading &&
        <LinearProgress color="secondary" />
      }
      <div className="dashboard-container">
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleClose}
            severity="error"
            variant="filled"
            sx={{ width: '100%' }}
          >
            FAILED TO GET LATEST DASHBOARD DATA
          </Alert>
        </Snackbar>
        <div className="container-fluid px-3 student-dashboard-wrapper">
          {/* Main Dashboard Grid */}
          <div className="row dashboard-main-row g-3 mb-4">
            {/* Full-width Welcome Banner */}
            <div className="col-12">
              <div className="hello mb-3">
                <div className="welcome-banner">
                  <div className="welcome-text">
                    <div className="welcome-title">Welcome back,</div>
                    <div className="welcome-username">{userName || sessionStorage.getItem("username")}</div>
                  </div>
                  <div className="welcome-illustration" aria-hidden="true">
                    <img src={Medal} className="welcome-illustration-img" alt="Medal" />
                  </div>
                </div>
              </div>
            </div>

            {/* Three cards on one row with equal height */}
            <div className="col-12">
              <div className="row g-3 dashboard-equal-height-row">
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="card-box enrolled-paper">
                    <EnrolledPaperCompletionGraph
                      completionPercentage={completionPercentage}
                      student_dashboard_initial_loading={student_dashboard_initial_loading}
                    />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="card-box paper-count">
                    <PaperCounts
                      availablePaperCount={availablePaperCount}
                      enrolledPaperCount={enrolledPaperCount}
                      completedPaperCount={completedPaperCount}
                      student_dashboard_initial_loading={student_dashboard_initial_loading}
                    />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="card-box credit-use h-auto w-auto">
                    <CreditsUsage
                      userCredits={userCredits}
                      student_dashboard_initial_loading={student_dashboard_initial_loading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Grid */}
          <div className="row">

            <div className="col-12 paper-col mb-4">
              <div className="dashboard-full-width-section">
                <div className="card-box">
                  <PaperDetails
                    availablePapers={availablePapers}
                    enrolledPapers={enrolledPapers}
                    completedPapers={completedPapers}
                    student_dashboard_initial_loading={student_dashboard_initial_loading}
                  />
                </div>
              </div>
            </div>

            {/* Previous announcements section commented out per request - announcements UI & logic disabled */}
            {/* 
            <div className="col-12 col-md-4 announcement-col mb-4">
              <div className="card-box announcement-box">
                <StudentAnnouncements
                  allRecentAnnouncements={allRecentAnnouncements}
                  weeklyAnnouncements={weeklyAnnouncements}
                  monthlyAnnouncements={monthlyAnnouncements}
                  student_dashboard_initial_loading={student_dashboard_initial_loading}
                />
              </div>
           </div>
           */}
          </div>

        </div>

      </div>
    </>
  );
};

export default TheStudentDashboard;
